import FeatureNotice from "@/v2-backoffice-client/feature/FeatureNotice"

export type FeatureUnpublishedNoticeProps = {
  className?: string
  /** Names the thing in the copy, e.g. "basemap". */
  subject: string
}

/**
 * The entry exists in the authoring catalog but has no row in the database
 * this backoffice is pointed at — normal for anything authored since the last
 * publish, and the reason its runtime-only fields have nothing to edit yet.
 */
function FeatureUnpublishedNotice(props: FeatureUnpublishedNoticeProps) {
  const { subject, className } = props

  return (
    <FeatureNotice tone="info" className={className}>
      Not published yet: this {subject} exists in the catalog but has no row in
      this environment&apos;s database. Publish it, and its access settings
      become editable here.
    </FeatureNotice>
  )
}

export default FeatureUnpublishedNotice
